module.exports = __webpack_public_path__ + "img/vuex.ed88ca9b.png";